export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const slugTranslations = [
  { from: '&', to: 'and' },
  { from: '.', to: 'dot' },
  { from: '#', to: 'sharp' },
  { from: '+', to: 'plus' },
]

export const sluggify = (name: string) => {
  //use slugTranslations to replace special characters with word equivalent
  const translatedSlug = slugTranslations.reduce(
    (specialSlug, { from, to }) => specialSlug.replace(new RegExp(`\\${from}`, "g"), to),
    name);

  //replace remaining special characters with '-'
  return translatedSlug.replace(/[^a-zA-Z0-9]{1}/g, '-').toLowerCase();

}


export const areListsEqual = <T,>(list1?: T[] | null, list2?: T[] | null): boolean => {
  if (!list1 && !list2) return true;
  if (list1?.length !== list2?.length) return false;
  const sorted1 = list1?.toSorted()
  const sorted2 = list2?.toSorted()
  return sorted1?.every((a, index) => a === sorted2?.[index]) || false;
}